var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contract-name" },
    [
      [
        _vm.signInfo.signStatus === 0
          ? [
              _vm.signInfo.selfSign === 1
                ? _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "dark",
                        content: _vm.signInfo.contractName,
                        placement: "bottom-start"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          on: {
                            click: function($event) {
                              return _vm.toSign({
                                signNo: _vm.signInfo.signNo,
                                applyNo: _vm.signInfo.applyNo,
                                approveId: _vm.signInfo.approveId,
                                aiCorpUserIdFlag: _vm.signInfo.aiCorpUserIdFlag,
                                fromDingTalk: _vm.signInfo.fromDingTalk
                              })
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.signInfo.contractName))]
                      )
                    ]
                  )
                : _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "dark",
                        content: _vm.signInfo.contractName,
                        placement: "bottom-start"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          on: {
                            click: function($event) {
                              return _vm.toApplyDetail()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.signInfo.contractName))]
                      )
                    ]
                  )
            ]
          : [1, -5, 2, 4].includes(_vm.signInfo.signStatus)
          ? [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    effect: "dark",
                    content: _vm.signInfo.contractName,
                    placement: "bottom-start"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      on: {
                        click: function($event) {
                          return _vm.toApplyDetail()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.signInfo.contractName))]
                  )
                ]
              )
            ]
          : _vm.signInfo.signStatus === -6
          ? [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    effect: "dark",
                    content: _vm.signInfo.contractName,
                    placement: "bottom-start"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      on: {
                        click: function($event) {
                          return _vm.$message.error("文件已过期")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.signInfo.contractName) +
                          "\n        "
                      )
                    ]
                  )
                ]
              )
            ]
          : _vm._e(),
        _vm.signInfo.signStatus === -3
          ? [
              _vm.signInfo.selfApprove === 1
                ? _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "dark",
                        content: _vm.signInfo.contractName,
                        placement: "bottom-start"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          on: {
                            click: function($event) {
                              return _vm.toAudit({
                                signNo: _vm.signInfo.signNo,
                                applyNo: _vm.signInfo.applyNo,
                                approveId: _vm.signInfo.approveId,
                                aiCorpUserIdFlag: _vm.signInfo.aiCorpUserIdFlag,
                                fromDingTalk: _vm.signInfo.fromDingTalk
                              })
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.signInfo.contractName))]
                      )
                    ]
                  )
                : _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "dark",
                        content: _vm.signInfo.contractName,
                        placement: "bottom-start"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          on: {
                            click: function($event) {
                              return _vm.toApplyDetail()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.signInfo.contractName))]
                      )
                    ]
                  )
            ]
          : _vm._e(),
        _vm.signInfo.signStatus === -4
          ? [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    effect: "dark",
                    content: _vm.signInfo.contractName,
                    placement: "bottom-start"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      on: {
                        click: function($event) {
                          return _vm.toApplyDetail()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.signInfo.contractName))]
                  )
                ]
              )
            ]
          : _vm._e()
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17dc534e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17dc534e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/apply-list/corpContractName.vue
// module id = YQIg
// module chunks = 23 24 27 31 41 42 50 103